import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import ModalVideo from "react-modal-video";
import imageData from "../../data/image-slider/location-slider.json";

const VideoContainer = ({ bgColorClass, spaceBottomClass }) => {
  const [modalStatus, isOpen] = useState(false);
  return (
    <div className={`video-popup ${spaceBottomClass ? spaceBottomClass : ""} ${bgColorClass}`}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="video-popup-3__image">
              <h2 className="title mb-30 text-center">
                Check out our Zebra Robotics center
              </h2>
              <button
                style={{
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL +
                    "/assets/zebra_images/covers/about-cover1.webp"
                  })`,
                  backgroundSize: "cover",
                  width: "100%",
                  height: "25rem",
                }}
                onClick={() => isOpen(true)}
              >
                <i className="fa fa-play-circle"></i>
              </button>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="video-popup__content">
              <h2 className="title mb-30">
                Take a look inside our Zebra Robotics center
              </h2>
              <p className="text mb-30">
                We seek to inspire the next generation of students to be
                confident and knowledgeable team players who strive to solve
                many of the world’s challenges using technology.
              </p>
              <div className="link mb-30">
                <Link to={process.env.PUBLIC_URL + "/about"}>
                  More About Us
                </Link>
              </div>
              <ModalVideo
                channel="youtube"
                isOpen={modalStatus}
                videoId="O_PZ8x6z6Ao"
                onClose={() => isOpen(false)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

VideoContainer.propTypes = {
  data: PropTypes.object,
};

export default VideoContainer;
